import { addToChainAfter, ApiHandler } from "@insite/client-framework/HandlerCreator";
import { GetCartPromotionsApiParameter } from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

import {
    chain,
    DispatchCompleteLoadPromotions,
} from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadPromotions";
import { CartLineModel, PromotionCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { selectPromotion } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = ApiHandler<GetCartPromotionsApiParameter, PromotionCollectionModel>;

interface Promotion {
    id: string;
    name: string;
    amount: number;
    amountDisplay: string;
    promotionApplied: boolean;
    orderLineId: string;
    promotionResultType: string;
    orderLine?: CartLineModel[]; // <-- Add this to store the matched cartline
}
function linkPromotionsWithCartlines(promotions: Promotion[], cartlines: CartLineModel[]): Promotion[] {
    return promotions.map(promotion => {
        const matchedLine = cartlines.find(cartline => cartline.id === promotion.orderLineId);

        if (matchedLine) {
            return {
                ...promotion,
                orderLine: [matchedLine], // Embed the matched cartline in an array
            };
        }

        return promotion; // Return as-is if no match
    });
}
export const GTMLoadPromotionsExtended: HandlerType = props => {
    const state = props.getState();
    const cart = getCurrentCartState(state).value;
    const cartlines = cart?.cartLines;
    const promotions = props.apiResult.promotions as Promotion[];
    const currentPage = getCurrentPage(state).name
    if (promotions?.length && cartlines?.length && currentPage === "Cart") {
        const newPromotion = linkPromotionsWithCartlines(promotions, cartlines);
        console.log(newPromotion);
        newPromotion.map(item => {
            const orderLine = item.orderLine?.map(item => {
                return {
                    item_id: item.id,
                    item_name: item.productName,
                    price: item.pricing?.unitNetPrice,
                    quantity: item.qtyOrdered,
                    item_brand: item.brand?.name,
                };
            });
            selectPromotion({
                event: "select_promotion",
                promotion_id: item.orderLineId,
                promotion_name: item.name,
                items: orderLine,
            });
        });
    }
};

addToChainAfter(chain, DispatchCompleteLoadPromotions, GTMLoadPromotionsExtended);
